import { Observable } from '@reactivex/rxjs';
import { axisBottom } from 'd3-axis';
import { select } from 'd3-selection';
import mapPropsStream from 'react-recompose/mapPropsStream';
import createEventHandler from 'react-recompose/createEventHandler';

import xAxisStyleNames from './styles.less';

const withD3XAxes = mapPropsStream(props => {
    const { handler: onRef, stream: refs } = createEventHandler();
    const propsObs = Observable.from(props).share();

    const renderD3AxisRefs = refs
        .filter(Boolean)
        .combineLatest(propsObs).take(1).map(initialRenderD3Axis)
        .combineLatest(propsObs)
        .do(updateD3Axis);

    return propsObs.merge(renderD3AxisRefs.ignoreElements()).map(props => ({ ...props, onRef }));
});

export const XAxis = withD3XAxes(renderXAxis);

const lineStyle = { stroke: '#BBB' };
function renderXAxis({ scale, width, clipPath, x, y, onRef, ...props }) {
    return (
        <g {...props} transform={`translate(${x}, ${y})`} clipPath={clipPath}>
            <line x1={-x} x2={width} y1={0.5} y2={0.5} style={lineStyle} />
            <g key="d3-x-axis" ref={onRef} />
        </g>
    );
}

function updateD3Axis([gx, props]) {
    gx.call(axisBottom(props.scale).tickSize(10));
}

function initialRenderD3Axis([axisRef, props]) {
    const axis = axisBottom(props.scale).tickSize(10);

    // Draw the new axis
    return select(axisRef)
        .append('g')
        .attr('class', xAxisStyleNames['x-axis'])
        .call(axis);
}
